export default __webpack_public_path__ + "static/media/15.a83fdc0e.png";